var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-404"},[_c('p',{staticClass:"--title"},[_vm._v("404!")]),_c('p',{staticClass:"--des"},[_vm._v("Page not found")]),_c('router-link',{staticClass:"s-button red-btn",attrs:{"to":{ name: 'home' }}},[_vm._v(" Back to home ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }